var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 268,
    viewBox: "0 0 268 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12020_10638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.248 216.637C112.285 221.498 125.984 215.681 130.845 203.644C135.707 191.607 129.89 177.908 117.853 173.047C105.816 168.186 92.117 174.003 87.2556 186.04C82.3943 198.077 88.2112 211.775 100.248 216.637Z",
    fill: "url(#paint0_radial_12020_10638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.248 216.637C112.285 221.498 125.984 215.681 130.845 203.644C135.707 191.607 129.89 177.908 117.853 173.047C105.816 168.186 92.117 174.003 87.2556 186.04C82.3943 198.077 88.2112 211.775 100.248 216.637Z",
    fill: "url(#paint1_linear_12020_10638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.248 216.637C112.285 221.498 125.984 215.681 130.845 203.644C135.707 191.607 129.89 177.908 117.853 173.047C105.816 168.186 92.117 174.003 87.2556 186.04C82.3943 198.077 88.2112 211.775 100.248 216.637Z",
    fill: "url(#paint2_radial_12020_10638)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12020_10638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.51 60.7954C173.109 56.8368 171.196 52.3317 167.238 50.7329C163.279 49.1342 158.774 51.0472 157.175 55.0058L152.479 66.6325C150.881 70.5911 152.794 75.0962 156.752 76.695C160.711 78.2937 165.216 76.3807 166.815 72.4221L171.51 60.7954Z",
    fill: "url(#paint3_radial_12020_10638)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_12020_10638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7697 82.7265C105.24 72.8712 114.903 65.5416 126.138 61.9681C137.373 58.3946 149.495 58.7948 160.47 63.1013L163.524 64.3348C174.409 68.8585 183.408 76.989 189.009 87.3618C194.61 97.7345 196.472 109.718 194.283 121.302L182.958 181.234C182.144 185.545 182.448 189.992 183.841 194.151L187.734 205.771C189.672 211.57 189.477 217.87 187.185 223.538L183.997 231.432C183.519 232.616 182.59 233.562 181.414 234.061C180.239 234.561 178.913 234.572 177.729 234.094L32.3508 175.38C31.1666 174.902 30.221 173.973 29.7218 172.797C29.2226 171.622 29.2109 170.296 29.6891 169.112L32.8773 161.218C35.1644 155.548 39.3995 150.879 44.821 148.053L55.6893 142.402C59.5799 140.373 62.8859 137.382 65.292 133.712L98.7697 82.7265Z",
    fill: "url(#paint4_linear_12020_10638)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.7697 82.7265C105.24 72.8712 114.903 65.5416 126.138 61.9681C137.373 58.3946 149.495 58.7948 160.47 63.1013L163.524 64.3348C174.409 68.8585 183.408 76.989 189.009 87.3618C194.61 97.7345 196.472 109.718 194.283 121.302L182.958 181.234C182.144 185.545 182.448 189.992 183.841 194.151L187.734 205.771C189.672 211.57 189.477 217.87 187.185 223.538L183.997 231.432C183.519 232.616 182.59 233.562 181.414 234.061C180.239 234.561 178.913 234.572 177.729 234.094L32.3508 175.38C31.1666 174.902 30.221 173.973 29.7218 172.797C29.2226 171.622 29.2109 170.296 29.6891 169.112L32.8773 161.218C35.1644 155.548 39.3995 150.879 44.821 148.053L55.6893 142.402C59.5799 140.373 62.8859 137.382 65.292 133.712L98.7697 82.7265Z",
    fill: "url(#paint5_linear_12020_10638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7697 82.7265C105.24 72.8712 114.903 65.5416 126.138 61.9681C137.373 58.3946 149.495 58.7948 160.47 63.1013L163.524 64.3348C174.409 68.8585 183.408 76.989 189.009 87.3618C194.61 97.7345 196.472 109.718 194.283 121.302L182.958 181.234C182.144 185.545 182.448 189.992 183.841 194.151L187.734 205.771C189.672 211.57 189.477 217.87 187.185 223.538L183.997 231.432C183.519 232.616 182.59 233.562 181.414 234.061C180.239 234.561 178.913 234.572 177.729 234.094L32.3508 175.38C31.1666 174.902 30.221 173.973 29.7218 172.797C29.2226 171.622 29.2109 170.296 29.6891 169.112L32.8773 161.218C35.1644 155.548 39.3995 150.879 44.821 148.053L55.6893 142.402C59.5799 140.373 62.8859 137.382 65.292 133.712L98.7697 82.7265Z",
    fill: "url(#paint6_radial_12020_10638)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_12020_10638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2195 144.863L55.8054 153.756L180.823 204.247L175.889 187.54L70.2195 144.863Z",
    fill: "url(#paint7_linear_12020_10638)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_12020_10638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.477 95.891C155.809 92.5944 158.303 89.9004 161.488 88.3188C164.672 86.7372 168.326 86.3776 171.757 87.3081C175.189 88.2386 178.161 90.3946 180.11 93.3682C182.059 96.3418 182.851 99.9268 182.336 103.445L170.308 185.279L125.658 167.246L154.477 95.891Z",
    fill: "url(#paint8_linear_12020_10638)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12020_10638",
    x: 151.915,
    y: 50.1684,
    width: 20.5711,
    height: 27.0912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.410907
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513634
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.564706 0 0 0 0 0.341176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12020_10638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_12020_10638",
    x: 21.1205,
    y: 59.5517,
    width: 176.111,
    height: 174.893,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8.21814
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.10907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905882 0 0 0 0 0.392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12020_10638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.02727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.02727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.866667 0 0 0 0 0.462745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_12020_10638",
    result: "effect2_innerShadow_12020_10638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.05454
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.05454
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.572549 0 0 0 0 0.32549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_12020_10638",
    result: "effect3_innerShadow_12020_10638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_12020_10638",
    x: 51.6963,
    y: 140.754,
    width: 133.236,
    height: 67.6017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.05454,
    result: "effect1_foregroundBlur_12020_10638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_12020_10638",
    x: 121.549,
    y: 82.6924,
    width: 65.0492,
    height: 106.696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.05454,
    result: "effect1_foregroundBlur_12020_10638"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12020_10638",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.583 218.693) rotate(-104.52) scale(18.9721 26.2014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68D61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12020_10638",
    x1: 102.493,
    y1: 198.356,
    x2: 99.6971,
    y2: 209.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#E57356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57356",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12020_10638",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.22 199.656) rotate(156.992) scale(26.1046 43.075)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#EA8059",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27068"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12020_10638",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.705 65.6128) rotate(-68.0077) scale(14.0008 8.42681)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12020_10638",
    x1: 124.141,
    y1: 199.738,
    x2: 43.6471,
    y2: 167.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28C37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12020_10638",
    x1: 116.943,
    y1: 211.338,
    x2: 124.156,
    y2: 193.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7737D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#FCA162",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12020_10638",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.991 140.06) rotate(168.131) scale(146.919 140.939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E69136",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#CF7D44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12020_10638",
    x1: 57.6687,
    y1: 154.509,
    x2: 177.103,
    y2: 202.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#F5A43C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12020_10638",
    x1: 182.152,
    y1: 171.09,
    x2: 124.805,
    y2: 147.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#FFEF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEF6D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12020_10638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205.454,
    height: 205.454,
    fill: "white",
    transform: "translate(76.9385) rotate(21.9923)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell2);
export default __webpack_public_path__ + "static/media/bell (2).c3091f3d1c8d321def2cb6b187f1a46a.svg";
export { ForwardRef as ReactComponent };